import config from '../../api/config'
//  const SECRET = 'e2ab018979a3c007014c10efb3b0c3fe'
// const hashDigest = sha256(SECRET)
// const hmacDigest = Base64.stringify(hmacSHA512('SITECONGRESS' + hashDigest, SECRET))
//  var CryptoJS = require('crypto-js')
// var AES = require('crypto-js/aes')
// var SHA256 = require('crypto-js/sha256')

const state = {
  // token: localStorage.getItem('access_token') || null,
  // organizationId: localStorage.getItem('organizationId') || null,
  // email: localStorage.getItem('email') || null,
  config: null,
  urlgral: null,
  telsoporte: null,
  telinfo: null,
  telregistro: null,
  telsalaA: null,
  telsalaB: null,
  telsalaC: null,
  url_fachada_video: null,
  video_recomendado: null,
  img_fachada1: null,
  img_fachada2: null,
  timetoken: null,
  url_registro: null,
  url_login: null,
  userValidTime: null,
  sharedInfoStand: null,
  marquesina: null,
  elearning: null,
  constancia: null,
  elearningmode: null,
  elearningmin: null,
  subnet: null,
  loginMessage: null,
  loginEmail: null,
  loginPassword: null,
  loginButton: null,
  loginHelp: null,
  loginPrivacy: null,
  mensajeConstancia: null,
  pctActivo: null,
  timeRefresh: null,
  TimeClose: null,
  msgCierre: null,
  menuInt: null,
  emailSoptec: null,
  isClosed: null
}

const getters = {
  Videofachada (state) {
    var data = localStorage.getItem('url_fachada_video')
    //  var bytes = CryptoJS.AES.decrypt(data, SECRET)
    //  var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  VideoRecomendado (state) {
    var data = localStorage.getItem('video_recomendado')
    return data
  },
  Soportetel (state) {
    var data = localStorage.getItem('telsoporte')
    //  var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  Registrotel (state) {
    var data = localStorage.getItem('telregistro')
    //  var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  Infotel (state) {
    var data = localStorage.getItem('telinfo')
    //  var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  UrlLogin (state) {
    var data = localStorage.getItem('urlLogin')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  UrlRegistro (state) {
    var data = localStorage.getItem('urlRegistro')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  Marquesina (state) {
    var data = localStorage.getItem('marquesina')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  Elearning (state) {
    var data = localStorage.getItem('elearning')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  ElearningMode (state) {
    var data = localStorage.getItem('elearningmode')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  ElearningMin (state) {
    var data = localStorage.getItem('elearningmin')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  Subnet (state) {
    var data = localStorage.getItem('subnet')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  LoginMessage (state) {
    var data = localStorage.getItem('loginMessage')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  LoginEmail (state) {
    var data = localStorage.getItem('loginEmail')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  LoginPassword (state) {
    var data = localStorage.getItem('loginPassword')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  LoginButton (state) {
    var data = localStorage.getItem('loginButton')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  LoginHelp (state) {
    var data = localStorage.getItem('loginHelp')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  LoginPrivacy (state) {
    var data = localStorage.getItem('loginPrivacy')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  MensajeConstancia (state) {
    var data = localStorage.getItem('mensajeConstancia')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  PctActivo (state) {
    var data = localStorage.getItem('pctActivo')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  TimeRefresh (state) {
    var data = localStorage.getItem('timeRefresh')
    // var bytes = CryptoJS.AES.decrypt(data, SECRET)
    // var originalText = bytes.toString(CryptoJS.enc.Utf8)
    return data
  },
  TimeClose (state) {
    var data = localStorage.getItem('TimeClose')
    return data
  },
  MsgCierre (state) {
    var data = localStorage.getItem('msgCierre')
    return data
  },
  MenuInt (state) {
    var data = localStorage.getItem('menuInt')
    return data
  },
  isClosed (state) {
    var data = localStorage.getItem('isClosed')
    return data
  }
}

const actions = {
  getConfigGral (context, credentials) {
    return config.apiConfig(credentials).then(response => {
      response.data.map(event => {
        // var ciphertext = CryptoJS.AES.encrypt(
        //   event.valueitem,
        //   SECRET
        // ).toString()
        var ciphertext = event.valueitem
        if (event.keyitem === 'urlgral') {
          localStorage.setItem('urlgral', ciphertext)
          context.commit('URLGRAL', event.valueitem)
        }
        if (event.keyitem === 'telsoporte') {
          const phones = ciphertext.split(',')
          const phone = phones[Math.floor(Math.random() * phones.length)]
          localStorage.setItem('telsoporte', phone)
          context.commit('TELSOPORTE', phone)
        }
        if (event.keyitem === 'telinfo') {
          const phones = ciphertext.split(',')
          const phone = phones[Math.floor(Math.random() * phones.length)]
          localStorage.setItem('telinfo', phone)
          context.commit('TELINFO', phone)
        }
        if (event.keyitem === 'telregistro') {
          const phones = ciphertext.split(',')
          const phone = phones[Math.floor(Math.random() * phones.length)]
          localStorage.setItem('telregistro', phone)
          context.commit('TELREGISTRO', phone)
        }
        if (event.keyitem === 'emailSoptec') {
          const emails = ciphertext.split(',')
          const email = emails[Math.floor(Math.random() * emails.length)]
          localStorage.setItem('emailSoptec', email)
          context.commit('EMAILSOPTEC', email)
        }
        if (event.keyitem === 'telsalaA') {
          localStorage.setItem('telsalaA', ciphertext)
          context.commit('TELSALAA', event.valueitem)
        }
        if (event.keyitem === 'telsalaA') {
          localStorage.setItem('telsalaA', ciphertext)
          context.commit('TELSALAA', event.valueitem)
        }
        if (event.keyitem === 'telsalaB') {
          localStorage.setItem('telsalaB', ciphertext)
          context.commit('TELSALAB', event.valueitem)
        }
        if (event.keyitem === 'telsalaC') {
          localStorage.setItem('telsalaC', ciphertext)
          context.commit('TELSALAC', event.valueitem)
        }
        if (event.keyitem === 'url_fachada_video') {
          localStorage.setItem('url_fachada_video', ciphertext)
          context.commit('URL_FACHADA_VIDEO', event.valueitem)
        }
        if (event.keyitem === 'video_recomendado') {
          localStorage.setItem('video_recomendado', ciphertext)
          context.commit('URL_VIDEO_RECOMENDADO', event.valueitem)
        }
        if (event.keyitem === 'img_fachada1') {
          localStorage.setItem('img_fachada1', ciphertext)
          context.commit('IMG_FACHADA_1', event.valueitem)
        }
        if (event.keyitem === 'img_fachada2') {
          localStorage.setItem('img_fachada2', ciphertext)
          context.commit('IMG_FACHADA_2', event.valueitem)
        }
        if (event.keyitem === 'timetoken') {
          localStorage.setItem('timetoken', ciphertext)
          context.commit('TIMETOKEN', event.valueitem)
        }
        if (event.keyitem === 'urllogin') {
          localStorage.setItem('urlLogin', ciphertext)
          context.commit('URL_LOGIN', event.valueitem)
        }
        if (event.keyitem === 'urlregistro') {
          localStorage.setItem('urlRegistro', ciphertext)
          context.commit('URL_REGISTRO', event.valueitem)
        }
        if (event.keyitem === 'userValidTime') {
          localStorage.setItem('userValidTime', ciphertext)
          context.commit('USER_VALID_TIME', event.valueitem)
        }
        if (event.keyitem === 'marquesina') {
          localStorage.setItem('marquesina', ciphertext)
          context.commit('MARQUESINA', event.valueitem)
        }
        if (event.keyitem === 'elearning') {
          localStorage.setItem('elearning', ciphertext)
          context.commit('ELEARNING', event.valueitem)
        }
        if (event.keyitem === 'sharedInfoStand') {
          localStorage.setItem('sharedInfoStand', ciphertext)
          context.commit('SHAREDINFOSTAND', event.valueitem)
        }
        if (event.keyitem === 'constancia') {
          localStorage.setItem('constancia', ciphertext)
          context.commit('CONSTANCIA', event.valueitem)
        }
        if (event.keyitem === 'elearningmode') {
          localStorage.setItem('elearningmode', ciphertext)
          context.commit('ELEARNINGMODE', event.valueitem)
        }
        if (event.keyitem === 'elearningmin') {
          localStorage.setItem('elearningmin', ciphertext)
          context.commit('ELEARNINGMIN', event.valueitem)
        }
        if (event.keyitem === 'subnet') {
          localStorage.setItem('subnet', ciphertext)
          context.commit('SUBNET', event.valueitem)
        }
        if (event.keyitem === 'loginMessage') {
          localStorage.setItem('loginMessage', ciphertext)
          context.commit('LOGINMESSAGE', event.valueitem)
        }
        if (event.keyitem === 'loginEmail') {
          localStorage.setItem('loginEmail', ciphertext)
          context.commit('LOGINEMAIL', event.valueitem)
        }
        if (event.keyitem === 'loginPassword') {
          localStorage.setItem('loginPassword', ciphertext)
          context.commit('LOGINPASSWORD', event.valueitem)
        }
        if (event.keyitem === 'loginButton') {
          localStorage.setItem('loginButton', ciphertext)
          context.commit('LOGINBUTTON', event.valueitem)
        }
        if (event.keyitem === 'loginButton') {
          localStorage.setItem('loginButton', ciphertext)
          context.commit('LOGINBUTTON', event.valueitem)
        }
        if (event.keyitem === 'loginHelp') {
          localStorage.setItem('loginHelp', ciphertext)
          context.commit('LOGINHELP', event.valueitem)
        }
        if (event.keyitem === 'loginPrivacy') {
          localStorage.setItem('loginPrivacy', ciphertext)
          context.commit('LOGINPRIVACY', event.valueitem)
        }
        if (event.keyitem === 'mensajeConstancia') {
          localStorage.setItem('mensajeConstancia', ciphertext)
          context.commit('MENSAJECONSTANCIA', event.valueitem)
        }
        if (event.keyitem === 'pctActivo') {
          localStorage.setItem('pctActivo', ciphertext)
          context.commit('PCTACTIVO', event.valueitem)
        }
        if (event.keyitem === 'timeRefresh') {
          localStorage.setItem('timeRefresh', ciphertext)
          context.commit('TIMEREFRESH', event.valueitem)
        }
        if (event.keyitem === 'TimeClose') {
          localStorage.setItem('TimeClose', ciphertext)
          context.commit('TIMECLOSE', event.valueitem)
        }
        if (event.keyitem === 'msgCierre') {
          localStorage.setItem('msgCierre', ciphertext)
          context.commit('MSGCIERRE', event.valueitem)
        }
        if (event.keyitem === 'menuInt') {
          localStorage.setItem('menuInt', ciphertext)
          context.commit('MENUINT', event.valueitem)
        }
        if (event.keyitem === 'closeAll') {
          localStorage.setItem('isClosed', ciphertext)
          context.commit('ISCLOSED', event.keyitem)
        }
      })
    })
  }
}
const mutations = {
  URLGRAL (state, params) {
    state.urlgral = params
  },
  TELSOPORTE (state, params) {
    state.telsoporte = params
  },
  TELINFO (state, params) {
    state.telinfo = params
  },
  TELREGISTRO (state, params) {
    state.telregistro = params
  },
  TELSALAA (state, params) {
    state.telsalaA = params
  },
  TELSALAB (state, params) {
    state.telsalaB = params
  },
  TELSALAC (state, params) {
    state.telsalaC = params
  },
  URL_FACHADA_VIDEO (state, params) {
    state.url_fachada_video = params
  },
  URL_VIDEO_RECOMENDADO (state, params) {
    state.video_recomendado = params
  },
  IMG_FACHADA_1 (state, params) {
    state.img_fachada1 = params
  },
  IMG_FACHADA_2 (state, params) {
    state.img_fachada2 = params
  },
  TIMETOKEN (state, params) {
    state.timetoken = params
  },
  URL_LOGIN (state, params) {
    state.url_logn = params
  },
  URL_REGISTRO (state, params) {
    state.url_registro = params
  },
  USER_VALID_TIME (state, params) {
    state.userValidTime = params
  },
  MARQUESINA (state, params) {
    // console.log('inside MARQUESINA')
    state.marquesina = params
  },
  ELEARNING (state, params) {
    state.elearning = params
  },
  SHAREDINFOSTAND (state, params) {
    state.sharedInfoStand = params
  },
  CONSTANCIA (state, params) {
    state.constancia = params
  },
  ELEARNINGMODE (state, params) {
    state.elearningmode = params
  },
  ELEARNINGMIN (state, params) {
    state.elearningmin = params
  },
  SUBNET (state, params) {
    state.subnet = params
  },
  LOGINMESSAGE (state, params) {
    state.loginMessage = params
  },
  LOGINEMAIL (state, params) {
    state.loginEmail = params
  },
  LOGINPASSWORD (state, params) {
    state.loginPassword = params
  },
  LOGINBUTTON (state, params) {
    state.loginButton = params
  },
  LOGINHELP (state, params) {
    state.loginHelp = params
  },
  LOGINPRIVACY (state, params) {
    state.loginPrivacy = params
  },
  MENSAJECONSTANCIA (state, params) {
    state.loginPrivacy = params
  },
  PCTACTIVO (state, params) {
    state.loginPrivacy = params
  },
  TIMEREFRESH (state, params) {
    state.loginPrivacy = params
  },
  TIMECLOSE (state, params) {
    state.TimeClose = params
  },
  MSGCIERRE (state, params) {
    state.msgCierre = params
  },
  MENUINT (state, params) {
    state.menuInt = params
  },
  EMAILSOPTEC (state, params) {
    state.emailSoptec = params
  },
  ISCLOSED (state, params) {
    state.isClosed = params
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/fachada.js